<template>
  <div class="email-status" v-if="!loading">
    <div class="event" v-for="(events, type) in groupedEmailEvents">
      <div class="content">
        <div v-if="type === 'processed'">
          <img src="/img/branding/dossierdata-icon-91x91.png" class="logo" alt="DossierData"/>
          Verzonden door DossierData
        </div>
        <div v-if="type === 'delivered'">
          <img v-if="hasProvider(events)" :src="getProvider(events).logo" class="logo"
               :alt="getProvider(events).name">
          <server-icon v-if="!hasProvider(events)" class="icon"></server-icon>
          Ontvangen door
          <span v-if="hasProvider(events)">
                        <a-tooltip placement="top">
                            <template slot="title">
                                <span>{{ events.find(Boolean).hostname }}</span>
                            </template>
                            {{ getProvider(events).hostname }}
                        </a-tooltip>
                    </span>
          <span v-if="!hasProvider(events)">
                        {{ events.find(Boolean).hostname }}
                    </span>
        </div>
        <div v-if="type === 'open'">
          <account-icon class="icon"></account-icon>
          Geopend door {{ email.to }}
        </div>
        <div v-if="type === 'bounce'">
          <close-octagon-icon class="icon"></close-octagon-icon>
          Kon niet worden bezorgd
        </div>
        <div v-if="type === 'spam'">
          <bug-icon class="icon"></bug-icon>
          Gemarkeerd als spam
        </div>
        <div v-if="type === 'dropped'">
          <email-search-icon class="icon"></email-search-icon>
          Onbekend e-mailadres
        </div>
      </div>
      <a-collapse v-if="type === 'open'" class="content" :bordered="false">
        <a-collapse-panel class="custom-ant-collapse-panel" :header="`${events.length} keer geopend`" key="1">
          <div class="content" v-for="event in events">
                        <span class="pull-right">
                            {{ event.created_at }}
                        </span>
            <check-circle-icon class="icon" style="color:#a8be27;"
                               v-if="isSuccessful(event)"></check-circle-icon>
            <close-circle-icon class="icon" style="color:#be0000;"
                               v-if="!isSuccessful(event)"></close-circle-icon>
            {{ event.name }}
            <div class="reason" v-if="event.reason">
              {{ event.reason }}
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
      <div class="content" v-if="type !== 'open'" v-for="event in events">
                <span class="pull-right">
                    {{ event.created_at }}
                </span>
        <check-circle-icon class="icon" style="color:#a8be27;" v-if="isSuccessful(event)"></check-circle-icon>
        <close-circle-icon class="icon" style="color:red;" v-if="!isSuccessful(event)"></close-circle-icon>
        {{ event.name }}
        <div class="reason" v-if="event.reason">
          {{ event.reason }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailApi from '~/api/email'
import emailEventApi from '~/api/emailEvent'

export default {
  name: 'EmailStatusComponent',
  props: {
    emailId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      groupedEmailEvents: [],
      email: {},
      loading: true,
    }
  },
  computed: {},
  methods: {
    isSuccessful (event) {
      return event.type === 'processed'
          || event.type === 'delivered'
          || event.type === 'open'
    },
    hasProvider (events) {
      return this.getProvider(events) !== null
    },
    getProvider (events) {
      let eventWithHostname = events.find(event => event.hostname !== null)

      if (eventWithHostname) {

        let hostname = eventWithHostname.hostname

        if (hostname.match(/.*outlook\.com/)) {
          return {
            name: 'Outlook',
            hostname: 'outlook.com',
            logo: '/img/logo/outlook.png',
          }
        } else if (hostname.match(/.*google\.com/) || hostname.match(/.*gmail\.com/)) {
          return {
            name: 'Gmail',
            hostname: 'google.com',
            logo: '/img/logo/google.png',
          }
        } else if (hostname.match(/.*exchangelabs\.com/)) {
          return {
            name: 'Microsoft Exchange',
            hostname: 'exchangelabs.com',
            logo: '/img/logo/exchange.png',
          }
        } else if (hostname.match(/.*dazure\.nl/)) {
          return {
            name: 'Dazure',
            hostname: 'mail.dazure.nl',
            logo: '/img/logo/dazure.png',
          }
        } else if (hostname.match(/.*taf\.local/)) {
          return {
            name: 'TAF',
            hostname: 'taf.nl',
            logo: '/img/logo/taf.png',
          }
        }
      }

      return null
    },
    loadEmailEvents () {
      Promise.all([
        emailApi.getById(this.emailId).then(response => {
          this.email = response.data
        }),
        emailEventApi.getByEmailIdGroupedByType(this.emailId).then(response => {
          this.groupedEmailEvents = response.data
        })
      ]).then(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadEmailEvents()
  }
}
</script>

<style scoped>
.email-status {
  position: relative;
}

.email-status .logo {
  vertical-align: baseline;
  margin-bottom: -4px;
  height: 20px;
}

.email-status .icon {
  font-size: 130%;
}

.email-status .event {
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 2px;
  margin: 3rem 0;
}

.email-status .event:not(:last-of-type):after {
  content: '';
  position: absolute;
  height: 30px;
  margin-left: 40px;
  border: 1px solid #e9ecef;
}

.email-status .event:last-of-type {
  margin-bottom: 0;
}

.email-status .event:first-of-type {
  margin-top: 0;
}

.email-status .event .content {
  padding: 1rem;
}

.email-status .event .reason {
  background: #f0f2f4;
  padding: .5rem;
  border-radius: 2px;
  font-family: monospace;
  font-size: 12px;
  margin-top: 1rem;
  border: 1px solid #e9ecef;
}

.email-status .custom-ant-collapse-panel {
  border: 0;
  margin: -5px;
}

.email-status .ant-collapse-content-box {
  padding: 0;
}
</style>
